// extracted by mini-css-extract-plugin
export default {"teamItem":"ArtistyList_teamItem__UJTJq","artistImg":"ArtistyList_artistImg__U1x9I"};